import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-[#070B14]">
      <span
        aria-hidden="true"
        className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-white/5 select-none pointer-events-none z-0"
      >
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-white">Page not found</h1>
        <p className="mt-2 text-base text-slate-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-slate-400">
          The page you&apos;re looking for doesn&apos;t exist or may have moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 bg-[#3B82F6] hover:bg-[#2563EB] text-white text-sm font-semibold px-5 py-3 rounded-lg transition-colors duration-200"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}